// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"12":"profiler","9777":"recorder"}[chunkId] + "." + {"12":"2abe214b","9777":"2e1a173a"}[chunkId] + ".js";
};